import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ad2d8b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "InvoiceDeliveryHistory" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "InvoiceDeliveryHistory__title" }, "Статусы накладной", -1))
const _hoisted_3 = {
  key: 0,
  class: "InvoiceDeliveryHistory__state mt-3"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "state__message mt-2" }, "Загрузка истории доставки...", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "state__message message--failed" }, " При загрузке истории доставки произошла ошибка ", -1))
const _hoisted_6 = {
  key: 1,
  class: "InvoiceDeliveryHistory__state mt-3"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "state__message" }, " Невомозжно загрузить историю доставки накладной без номера накладной ", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 2,
  class: "InvoiceDeliveryHistory__items mt-3"
}
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = { class: "relative" }
const _hoisted_12 = { class: "mr-2 z-10 bg-white" }
const _hoisted_13 = {
  key: 0,
  class: "fas fa-check-circle text-blue-500"
}
const _hoisted_14 = { class: "item__title" }
const _hoisted_15 = {
  key: 0,
  class: "item__title"
}
const _hoisted_16 = {
  key: 0,
  class: "text-sm w-max"
}
const _hoisted_17 = {
  key: 1,
  class: "text-sm w-max"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_check_icon = _resolveComponent("check-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.loading || _ctx.failed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_loader, { class: "primary" }),
                _hoisted_4
              ], 64))
            : (_ctx.failed)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_5,
                  _createVNode(_component_the_button, {
                    class: "primary small mt-2",
                    onClick: _ctx.emitRefresh
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Обновить")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ], 64))
              : _createCommentVNode("", true)
        ]))
      : (!Boolean(_ctx.invoiceNumber))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.history, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(['InvoiceDeliveryHistory__item', { primary: Boolean(item.date) }]),
                key: i
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      (item.date)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_13))
                        : (_openBlock(), _createBlock(_component_check_icon, { key: 1 }))
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(`item__line ${
                                item.date ? 'item__line--blue ' : 'item__line--black '
                            } `)
                    }, null, 2)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_14, [
                      (item.changed_delivery_date)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(item.status_title) + " (на " + _toDisplayString(item.changed_delivery_date) + ") ", 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(item.status_title), 1)
                          ], 64))
                    ]),
                    (item.status_source === 7)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_15, "(Автозакрытие)"))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (item.date)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                      (_ctx.takeTimeSlotTime && (item.status_code === 202 || item.status_code === 203))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.formatDate(item.date, true)) + " (" + _toDisplayString(_ctx.formatTimeRange(_ctx.takeTimeSlotTime)) + ") ", 1)
                          ], 64))
                        : (_ctx.deliveryTimeSlotTime && (item.status_code === 210 || item.status_code === 211))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(_ctx.formatDate(item.date, true)) + " (" + _toDisplayString(_ctx.formatTimeRange(_ctx.deliveryTimeSlotTime)) + ") ", 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createTextVNode(_toDisplayString(_ctx.formatDate(item.date, false)), 1)
                            ], 64))
                    ]))
                  : (Boolean(item.predict_date))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                        (_ctx.takeTimeSlotTime && (item.status_code === 202 || item.status_code === 203))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.formatDate(item.predict_date, true)) + " (" + _toDisplayString(_ctx.formatTimeRange(_ctx.takeTimeSlotTime)) + ") ", 1)
                            ], 64))
                          : (_ctx.deliveryTimeSlotTime && (item.status_code === 210 || item.status_code === 211))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(_ctx.formatDate(item.predict_date, true)) + " (" + _toDisplayString(_ctx.formatTimeRange(_ctx.deliveryTimeSlotTime)) + ") ", 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createTextVNode(_toDisplayString(_ctx.formatDate(item.predict_date, false)), 1)
                              ], 64))
                      ]))
                    : _createCommentVNode("", true)
              ], 2))
            }), 128))
          ]))
  ]))
}